import countries from './countries';
import entity_types from './entity_types';
import languages from './languages';
import payment_types from './payment_types';
import product_types from './product_types';
import tasks_statuses from './tasks_statuses';
import terms from './terms';
import texts from '../../../lang/fr.json';

export default {
    countries,
    languages,
    payment_types,
    product_types,
    tasks_statuses,
    terms,
    ...entity_types,
    ...texts
};
